<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container">
        <a class="navbar-brand" href="#">KASZK Digitalizáció</a>
        <div class="navbar-nav">
          <button
            class="btn btn-outline-light me-2"
            @click="currentView = 'form'"
            :class="{ active: currentView === 'form' }"
          >
            Hallgatói űrlap
          </button>
          <button
            v-if="isAuthenticated"
            class="btn btn-outline-light me-2"
            @click="currentView = 'list'"
            :class="{ active: currentView === 'list' }"
          >
            Hallgatók listája
          </button>
          <button
            class="btn btn-outline-light me-2"
            @click="currentView = 'admin'"
            :class="{ active: currentView === 'admin' }"
          >
            {{ isAuthenticated ? 'Admin Panel' : 'Admin Belépés' }}
          </button>
          <button
            v-if="isAuthenticated"
            class="btn btn-outline-danger"
            @click="logout"
          >
            Kilépés ({{ user?.username }})
          </button>
        </div>
      </div>
    </nav>

    <div class="container mt-4">
      <StudentForm
        v-if="currentView === 'form'"
        :editingStudent="editingStudent"
        :isAuthenticated="isAuthenticated"
        @studentAdded="handleStudentAdded"
        @studentUpdated="handleStudentUpdated"
        @cancelEdit="cancelEdit"
      />
      <StudentList
        v-else-if="currentView === 'list' && isAuthenticated"
        :students="students"
        @edit-student="handleEditStudent"
        @delete-student="handleDeleteStudent"
      />
      <AdminPanel 
        v-else-if="currentView === 'admin'" 
        @login-success="handleLoginSuccess"
        @logout="handleLogout"
      />
      <div v-else-if="currentView === 'list' && !isAuthenticated" class="alert alert-warning">
        <h4>Hozzáférés megtagadva</h4>
        <p>A hallgatók listájának megtekintéséhez admin bejelentkezés szükséges.</p>
        <button class="btn btn-primary" @click="currentView = 'admin'">
          Admin belépés
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StudentForm from "./components/StudentForm.vue";
import StudentList from "./components/StudentList.vue";
import AdminPanel from "./components/AdminPanel.vue";
import API_CONFIG from "./config/api.js";

export default {
  name: "App",
  components: {
    StudentForm,
    StudentList,
    AdminPanel,
  },
  data() {
    return {
      currentView: "form",
      students: [],
      editingStudent: null,
      isAuthenticated: false,
      user: null,
    };
  },
  async mounted() {
    await this.checkAuthStatus();
    if (this.isAuthenticated) {
      this.loadStudents();
    }
  },
  methods: {
    async loadStudents() {
      try {
        const response = await axios.get(
          API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.STUDENTS
        );
        this.students = response.data;
      } catch (error) {
        console.error("Error loading students:", error);
      }
    },
    handleStudentAdded() {
      this.loadStudents();
    },
    handleStudentUpdated() {
      this.editingStudent = null;
      this.loadStudents();
      // Redirect to list only if user is authenticated, otherwise stay on form
      if (this.isAuthenticated) {
        this.currentView = "list";
      }
    },
    handleEditStudent(student) {
      if (this.isAuthenticated) {
        this.editingStudent = student;
        this.currentView = "form";
      } else {
        alert("Admin bejelentkezés szükséges a szerkesztéshez!");
        this.currentView = "admin";
      }
    },
    cancelEdit() {
      this.editingStudent = null;
    },
    async checkAuthStatus() {
      try {
        const response = await axios.get(
          API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.AUTH.STATUS,
          { withCredentials: true }
        );
        this.isAuthenticated = response.data.authenticated;
        this.user = response.data.user;
      } catch (error) {
        console.error("Auth check error:", error);
        this.isAuthenticated = false;
        this.user = null;
      }
    },
    handleLoginSuccess(user) {
      this.isAuthenticated = true;
      this.user = user;
      this.loadStudents();
    },
    handleLogout() {
      this.isAuthenticated = false;
      this.user = null;
      this.students = [];
      this.editingStudent = null;
      this.currentView = "form";
    },
    async logout() {
      try {
        await axios.post(
          API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.AUTH.LOGOUT,
          {},
          { withCredentials: true }
        );
        this.handleLogout();
      } catch (error) {
        console.error("Logout error:", error);
        // Even if logout fails, clear local state
        this.handleLogout();
      }
    },
    async handleDeleteStudent(studentId) {
      try {
        await axios.delete(
          `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.STUDENTS}/${studentId}`,
          {
            withCredentials: true,
          }
        );
        this.loadStudents();
        alert("Hallgató sikeresen törölve!");
      } catch (error) {
        console.error("Error deleting student:", error);
        alert("Hiba történt a törlés során!");
      }
    },
  },
};
</script>

<style>
@import "bootstrap/dist/css/bootstrap.min.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.navbar-nav .btn.active {
  background-color: #495057;
}
</style>
